import { FC, useContext } from 'react';

import { Button, DotsMenu } from '@smartshell/ui-kit';
import cn from 'classnames';

import { useIsFeatureAvailable } from 'features';
import { useWindowResize } from 'hooks';
import { LocalizationContext } from 'localization';

import { GameAccountsContext } from '../../GameAccounts';
import { IGameAccountsTableHeaderProps } from '../../interfaces';
import { Shortcuts } from './Shortcuts';
import s from './TableHeader.module.scss';
import { useDotsMenuItems } from './useDotsMenuItems';

export const TableHeader: FC<IGameAccountsTableHeaderProps> = ({ group }) => {
  const { t } = useContext(LocalizationContext);
  const { openAccountManager } = useContext(GameAccountsContext) ?? {};
  const { items } = useDotsMenuItems();
  const isAvailable = useIsFeatureAvailable('game_accounts');
  const size = useWindowResize();

  return (
    <div className={s['table-header']}>
      <div className={s.info}>
        {group.title}
        <Shortcuts shortcuts={group.shortcuts} />
        {size.width <= 960 && (
          <DotsMenu
            data={group}
            items={items}
            className={cn(s.menu, s.mobile)}
          />
        )}
      </div>
      <div className={s.controls}>
        <Button
          variant="secondary"
          className={s['add-account']}
          disabled={!isAvailable}
          iconName="CirclePlusIcon"
          onClick={() => {
            if (!openAccountManager) {
              return;
            }

            openAccountManager(group);
          }}
        >
          {t('accounts.add')}
        </Button>
        {size.width > 960 && (
          <DotsMenu data={group} items={items} className={s.menu} />
        )}
      </div>
    </div>
  );
};
